import Vue from 'vue'
import VueI18n from 'vue-i18n'
import general from './locales/en/general'
import extradatas from './locales/en/extradatas'
import enCTExtradatas from './locales/enCloudTask/extradatas'
import esCTExtradatas from './locales/esCloudTask/extradatas'
import esExtradatas from './locales/es/extradatas'
import cnExtradatas from './locales/cn/extradatas'
import ptExtradatas from './locales/pt/extradatas'
import deExtradatas from './locales/de/extradatas'
import inExtradatas from './locales/in/extradatas'
import enCTGeneral from './locales/enCloudTask/general'
import esCTGeneral from './locales/esCloudTask/general'
import esGeneral from './locales/es/general'
import ptGeneral from './locales/pt/general'
import cnGeneral from './locales/cn/general'
import deGeneral from './locales/de/general'
import inGeneral from './locales/in/general'
import enCTLogin from './locales/enCloudTask/login'
import esCTLogin from './locales/esCloudTask/login'
import login from './locales/en/login'
import esLogin from './locales/es/login'
import ptLogin from './locales/pt/login'
import cnLogin from './locales/cn/login'
import deLogin from './locales/de/login'
import inLogin from './locales/in/login'
import enCTOrders from './locales/enCloudTask/orders'
import esCTOrders from './locales/esCloudTask/orders'
import orders from './locales/en/orders'
import esOrders from './locales/es/orders'
import ptOrders from './locales/pt/orders'
import cnOrders from './locales/cn/orders'
import deOrders from './locales/de/orders'
import inOrders from './locales/in/orders'
import rules from './locales/en/rules'
import enCTRules from './locales/enCloudTask/rules'
import esCTRules from './locales/esCloudTask/rules'
import esRules from './locales/es/rules'
import ptRules from './locales/pt/rules'
import cnRules from './locales/cn/rules'
import deRules from './locales/de/rules'
import inRules from './locales/in/rules'
import sidebar from './locales/en/sidebar'
import enCTSidebar from './locales/enCloudTask/sidebar'
import esCTSidebar from './locales/esCloudTask/sidebar'
import esSidebar from './locales/es/sidebar'
import ptSidebar from './locales/pt/sidebar'
import cnSidebar from './locales/cn/sidebar'
import deSidebar from './locales/de/sidebar'
import inSidebar from './locales/in/sidebar'
import toolbar from './locales/en/toolbar'
import enCTToolbar from './locales/enCloudTask/toolbar'
import esCTToolbar from './locales/esCloudTask/toolbar'
import esToolbar from './locales/es/toolbar'
import ptToolbar from './locales/pt/toolbar'
import cnToolbar from './locales/cn/toolbar'
import deToolbar from './locales/de/toolbar'
import inToolbar from './locales/in/toolbar'
Vue.use(VueI18n)

export default new VueI18n({
  locale: navigator.language,
  fallbackLocale: 'en',
  silentTranslationWarn: true,
  messages: {
    en: {
      ...extradatas,
      general: {
        ...general
      },
      login: {
        ...login
      },
      orders: {
        ...orders
      },
      rules: {
        ...rules
      },
      sidebar: {
        ...sidebar
      },
      toolbar: {
        ...toolbar
      }
    },
    enCloudTask: {
      ...enCTExtradatas,
      general: {
        ...enCTGeneral
      },
      login: {
        ...enCTLogin
      },
      orders: {
        ...enCTOrders
      },
      rules: {
        ...enCTRules
      },
      sidebar: {
        ...enCTSidebar
      },
      toolbar: {
        ...enCTToolbar
      }
    },
    es: {
      ...esExtradatas,
      general: {
        ...esGeneral
      },
      login: {
        ...esLogin
      },
      orders: {
        ...esOrders
      },
      rules: {
        ...esRules
      },
      sidebar: {
        ...esSidebar
      },
      toolbar: {
        ...esToolbar
      }
    },
    esCloudTask: {
      ...esCTExtradatas,
      general: {
        ...esCTGeneral
      },
      login: {
        ...esCTLogin
      },
      orders: {
        ...esCTOrders
      },
      rules: {
        ...esCTRules
      },
      sidebar: {
        ...esCTSidebar
      },
      toolbar: {
        ...esCTToolbar
      }
    },
    'es-419': {
      esExtradatas,
      general: {
        ...esGeneral
      },
      orders: {
        ...esOrders
      },
      login: {
        ...esLogin
      },
      rules: {
        ...esRules
      },
      sidebar: {
        ...esSidebar
      },
      toolbar: {
        ...esToolbar
      }
    },
    pt: {
      ptExtradatas,
      general: {
        ...ptGeneral
      },
      orders: {
        ...ptOrders
      },
      login: {
        ...ptLogin
      },
      rules: {
        ...ptRules
      },
      sidebar: {
        ...ptSidebar
      },
      toolbar: {
        ...ptToolbar
      }
    },
    cn: {
      cnExtradatas,
      general: {
        ...cnGeneral
      },
      orders: {
        ...cnOrders
      },
      login: {
        ...cnLogin
      },
      rules: {
        ...cnRules
      },
      sidebar: {
        ...cnSidebar
      },
      toolbar: {
        ...cnToolbar
      }
    },
    de: {
      deExtradatas,
      general: {
        ...deGeneral
      },
      orders: {
        ...deOrders
      },
      login: {
        ...deLogin
      },
      rules: {
        ...deRules
      },
      sidebar: {
        ...deSidebar
      },
      toolbar: {
        ...deToolbar
      }
    },
    in: {
      inExtradatas,
      general: {
        ...inGeneral
      },
      orders: {
        ...inOrders
      },
      login: {
        ...inLogin
      },
      rules: {
        ...inRules
      },
      sidebar: {
        ...inSidebar
      },
      toolbar: {
        ...inToolbar
      }
    }
  }
})
